// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"ChangePassword_submitButton__384Cc"};